import { API_LARK_URL, API_URL, AUTH, AUTH_LARK_URL } from '../Constants'
import { getAuth, postAuth } from '../utils/auth'
import { post } from '../utils/axios'

export const LoginAPI = async (data) => {
  return await postAuth({
    url: API_URL,
    auth: AUTH,
    path: 'api/v1/checkLogin',
    body: data
  })
}

export const checkTokenAPI = async (data) => {
  return await postAuth({
    url: API_URL,
    auth: AUTH,
    path: 'api/v1/checkToken',
    body: data
  })
}

export const loginLarkAPI = async (data) => {
  return postAuth({
    url: API_LARK_URL,
    auth: AUTH_LARK_URL,
    path: 'v1/auth/lark',
    body: data
  }).catch((error) => {
    throw new Error(error.message)
  })
}

export const loginLarkCallbackAPI = async (body) => {
  return await postAuth({
    path: `v1/auth/lark/callback`,
    body,
    url: API_LARK_URL,
    auth: AUTH_LARK_URL
  })
}

export const orgsAPI = async () => {
  return await getAuth('v1/auths/orgs')
}

export const refreshTokenAPI = async (data) => {
  return await post('v1/refreshToken', data)
}

export const versionBackEndAPI = async () => {
  return await getAuth('v1/version')
}
